module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/step1_5-622765eca92bcb752d2db236be99bdce.png";